



























import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'Logo',
    components: {},
})
export default class Logo extends Vue {
    private get logo() {
        return this.$vuetify.theme.themes.light.logo;
    }
}
